import { ModalProps } from './components/Modal/Modal';
import { CMAType } from './types';

export const MODAL_TEXT = [
  {
    title: 'Reset Capital Market Assumptions',
    message: 'Are you sure you want to reset your assumptions to the default?',
    successLabel: 'Yes',
    variant: 'error',
  },
  {
    title: 'Warning',
    message:
      'Are you sure you want to change these settings? Doing so will change the capital market assumptions for all plans within your organization.',
    successLabel: 'I’m Sure',
    variant: 'warning',
  },
] as Pick<ModalProps, 'title' | 'message' | 'successLabel' | 'variant'>[];

export const DROPDOWN_OPTIONS = [
  { label: '2026 JP Morgan Forward Assumptions', value: CMAType.Year2026CMAs },
  {
    label: '2025 JP Morgan Forward Assumptions',
    value: CMAType.Year2025CMAs,
  },
  {
    label: '2024 JP Morgan Forward Assumptions',
    value: CMAType.Year2024CMAs,
  },
  {
    label: '2023 JP Morgan Forward Assumptions',
    value: CMAType.Year2023CMAs,
  },
  {
    label: '2022 JP Morgan Forward Assumptions',
    value: CMAType.Year2022CMAs,
  },
  {
    label: '2021 JP Morgan Forward Assumptions',
    value: CMAType.Year2021CMAs,
  },
  {
    label: '2020 JP Morgan Forward Assumptions',
    value: CMAType.Year2020CMAs,
  },
  {
    label: '1/1/2006 - 12/31/2025 Historical Average',
    value: CMAType.Year2006To2025CMAs,
  },
  {
    label: 'Custom Assumptions',
    value: CMAType.CustomCMAs,
  },
];
